import React from 'react'
import AppTheme from '../../shared/theming-sc/AppTheme'
import Datatable from './'

// eslint-disable-next-line require-await
const rehydrator = async domNode => {
  const readData = prop => {
    const data = domNode.getAttribute(`data-${prop}`)

    return data ? JSON.parse(decodeURIComponent(data)) : null
  };

  const props = { ...readData('options') }

  props.i18n = readData('i18n')

  return (
    <AppTheme mode='refinitiv'>
      <Datatable {...props} />
    </AppTheme>
  )
}

export default rehydrator
